import type { AxiosInstance } from 'axios';
import axiosInstance from './interceptor';

export class BaseAPIService {
  protected api: AxiosInstance;

  constructor() {
    // Reuse the shared axios instance with interceptors configured in interceptor.ts
    this.api = axiosInstance;
  }

  // Add common HTTP methods
  async get(url: string, config?: any) {
    return this.api.get(url, config);
  }

  async post(url: string, data?: any, config?: any) {
    return this.api.post(url, data, config);
  }

  async put(url: string, data?: any, config?: any) {
    return this.api.put(url, data, config);
  }

  async patch(url: string, data?: any, config?: any) {
    return this.api.patch(url, data, config);
  }

  async delete(url: string, config?: any) {
    return this.api.delete(url, config);
  }
}

// Create and export a default instance
const baseAPIService = new BaseAPIService();
export default baseAPIService;
